/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FormatSuperscriptIcon
 */
export default class FormatSuperscriptIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M4.7 4.285l.083.093 4.774 6.013 4.776-6.013.084-.093a1 1 0 011.554 1.234l-.072.103L10.834 12l5.065 6.378a1 1 0 01-1.482 1.337l-.084-.093-4.776-6.014-4.774 6.014-.084.093a1 1 0 01-1.554-1.234l.072-.103L8.28 12 3.217 5.622a1 1 0 011.482-1.337zM19.816 4c.574 0 .995.119 1.382.46.694.613.943 1.64.22 2.698-.223.328-.485.6-.935 1.003l-.705.625-.108.1h1.704c.314 0 .574.231.618.533L22 9.51a.625.625 0 01-.533.618l-.092.007h-2.78a.625.625 0 01-.624-.625c0-.388.158-.742.44-1.096l.145-.175c.128-.147.271-.283.55-.53l.666-.59c.301-.276.48-.47.615-.666.328-.482.245-.827-.015-1.056-.125-.11-.258-.148-.555-.148-.317 0-.596.36-.596.853a.625.625 0 11-1.25 0c0-1.125.76-2.103 1.846-2.103z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

